<template>
    <b-row>
        <b-col
            cols="12"
            v-for='(event, index, key) in this.events'
            :key="'col_'+index"
            :md="( index == 0 ? 12 : 4 )"
        >
            <event-box
                :event='event'
                :index="index"
            >
            </event-box>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: "EventListing",
        props: {
            events: Array
        }
    }
</script>